import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import GarrisonInfoService from "../../../../../../services/reports/garrison-info-service.js";

function LinkButton({ children, onClick }) {
    return (
        <button
            type="button"
            className="text-[#1588F3] underline cursor-pointer  print:text-inherit print:!no-underline"
            onClick={onClick}
        >
            {children}
        </button>
    )
}

export default function Dispatch({ data, title }) {
    const [gridApi, setGridApi] = useState(null);
    const dispatch = data?.garrison?.dispatch ?? [];
    const boName = data?.garrison?.boName ?? "";

    const formatAddress = (row) => {
        const factPlace = row?.dispatch_factplace?.trim();
        const street = row?.dispatch_factstreet?.trim();
        const neighborhood = row?.dispatch_factneighborhood?.trim();
        const number = row?.dispatch_factnumber?.trim();

        return [factPlace, street, neighborhood, number]
            .filter(Boolean)
            .join(", ");
    };

    const columnDefs = useMemo(() => ([
        {
            headerName: "Talão",
            field: "dispatch_numbercheckbook",
            flex: 5,
            cellRenderer: ({ data, value }) => {
                const dispatchId = data?.dispatch_id;

                if (!value) {
                    return "Sem talão";
                }

                return (
                    <LinkButton onClick={() => {window.open(GarrisonInfoService.getDispatch(dispatchId), "_blank")}}>
                        {value}
                    </LinkButton>
                )
            }
        },
        {
            headerName: boName,
            field: "dispatch_occurrencenumber",
            flex: 5,
            cellRenderer: ({ data, value }) => {
                const occurrenceId = data?.dispatch_occurrencenumber;

                return (
                    <LinkButton onClick={() => window.open(GarrisonInfoService.getOccurrence(occurrenceId), "_blank")}>
                        {value}
                    </LinkButton>
                )
            }
        },
        {headerName: "D/H inicial", field: "dispatch_start", flex: 7, wrapText: true, autoHeight: true},
        {headerName: "D/H final", field: "dispatch_end", flex: 7, wrapText: true, autoHeight: true},
        {headerName: "Natureza", field: "dispatch_nature", flex: 10, wrapText: true, autoHeight: true},
        {
            headerName: "Endereço",
            field: "dispatch_address",
            valueGetter: (params) => formatAddress(params.data),
            flex: 21,
            wrapText: true,
            autoHeight: true,
        },
    ]), [boName]);

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={dispatch ?? []}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: true }}
                    animateRows={false}
                    suppressCellFocus={true}
                    suppressRowHoverHighlight={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    formatters={{
                        dispatch_address: formatAddress
                    }}
                    gridApi={gridApi}
                    className="!border-0 w-full -mx-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}